import React from 'react'
import { useLocale } from '../contexts/LocaleContext'
import Reveal from './Reveal'

const screens = [
  { key: 'logs', src: '/assets/simulator_workout.png', alt: 'Workout log screen with sets and reps in Gym Journey' },
  { key: 'graphs', src: '/assets/simulator_results.png', alt: 'Progress graph showing strength and cardio trends in Gym Journey' },
  { key: 'builder', src: '/assets/simulator_preview.png', alt: 'Custom workout builder screen in Gym Journey' }
]

function Screenshots() {
  const { t } = useLocale()

  return (
    <section id="screenshots" className="section section--glow">
      <div className="container">
        <Reveal>
          <h2>{t.screenshots.title}</h2>
          <p className="lead">{t.screenshots.lead}</p>
        </Reveal>
        <div className="screens">
          {screens.map((screen, i) => (
            <Reveal as="figure" className={`screen screen--${i}`} key={screen.key} delay={i * 0.12} y={40}>
              <img src={screen.src} width="1419" height="2796" alt={screen.alt} loading="lazy" />
              <figcaption>{t.screenshots[screen.key].caption}</figcaption>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Screenshots
